import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { toastMessage } from '../../utils/toast';
import * as jobsActions from '../../Redux/Actions/jobs';
import * as adminAnalyticsActions from '../../Redux/Actions/adminAnalytics';
import * as staffAnalyticsActions from '../../Redux/Actions/staffAnalytics';
import * as commonActions from '../../Redux/Actions/common';
import { initiateLogOut } from '../../utils/initiate';
import Modal from '../Ui/Modal';
import Warning from '../Ui/400';
import { AdminJobsChart, SLAJobsChart, RecentJobs, Metrics, HorizontalBarChart } from './chart';
import JobsCount from './jobsCount';
import JobsCount2 from './jobsCount2';
import { getFlyerNotifications, updateFlyerNotification } from '../../Redux/Actions/notification';
import FlyerModal from './flyerModal';

const Dashboard = ({ history }) => {
    const [notificationData, setNotificationData] = useState([]);
    const [jobNotifyModal, setJobNotifyModal] = useState(false);
    const [jobID, setJobID] = useState('');
    const [jobData, setJobData] = useState('');

    const [jobsCountData, setJobsCountData] = useState([]);
    const [adminJobsData, setAdminJobsData] = useState([]);
    const [recentJobsJobsData, setRecentJobsJobsData] = useState([]);
    const [metricesData, setMetricesData] = useState([]);
    const [slaJobsData, setSlaJobsData] = useState([]);
    const [overAllCount, setOverAllCount] = useState([]);
    const [flyerNotificationConfigs, setFlyerNotificationConfigs] = useState({
        data: [],
        url: null,
        id: null, 
        loading: false
    });

    const [errStatus, setErrStatus] = useState(200);
    const userData = useSelector(({User}) => User.data);
    const pageLoading = useSelector(({Common}) => Common.pageLoading);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        let payload = {
            userId: userData?.UserId,
            statusType: "UnRead",
        };
        getFlyerNotification(payload);
    
    }, [userData]);

    const getFlyerNotification = (payload) => {
        getFlyerNotifications(payload).then(res => {
            if(res?.data) {
                setFlyerNotificationConfigs({
                    data: res?.data,
                    url: res?.data?.[0]?.documentURL,
                    id: res?.data?.[0]?.id
                });
            }
        });
    };

    const updateStatus = (id) => {
        setFlyerNotificationConfigs((preState) => ({...preState, loading: true }));
        let payload = {
            notificationIds : [id]
        }
        updateFlyerNotification(payload).then(() => {
            const updatedItems = [...flyerNotificationConfigs.data];
            updatedItems.shift();
            // const updatedItems = flyerNotificationConfigs.data?.filter(item => item.id !== id);
            setFlyerNotificationConfigs({ data: updatedItems, url: updatedItems[0]?.documentURL, id: updatedItems[0]?.id, loading: false });
        }).catch((error) => {
            console.log(error);
            setFlyerNotificationConfigs((preState) => ({...preState, loading: false }));
        });
    }


    useEffect(() => {
        dispatch(commonActions.pageLoading(true));
        jobsActions.getJobNotifications('Pending').then(res => {
            if(res && res.data){
                setNotificationData(res.data);
            }else{
                toastMessage('error', 'Unable to load the notifications');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });

        jobsActions.getJobCountsForActionRequested().then(res => {
            if(res && res.data){
                setOverAllCount(res.data);
            }else{
                toastMessage('error', (res && res.message) || 'Unable to load the jobs count');
            }
        }).catch(err => {
            setErrStatus(err.response.status);
        });

        let reportType = (userData.Role === 'TYPINGCENTERSTAFF') ? staffAnalyticsActions : adminAnalyticsActions;
        reportType.getAllDashboardJobs().then(res => {
            if(res && res.data){
                setAdminJobsData(res.data);
            }else{
                toastMessage('error', (res && res.message) || 'Unable to load the Jobs');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });

        reportType.getAllSLAForJobs().then(res => {
            if(res && res.data){
                setSlaJobsData(res.data);
            }else{
                toastMessage('error', (res && res.message) || 'Unable to load the sla jobs');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });

        reportType.getAllRecentJobs().then(res => {
            if(res && res.data){
                setRecentJobsJobsData(res.data);
            }else{
                toastMessage('error', (res && res.message) || 'Unable to load the recent jobs');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });

        reportType.getAllMetrices().then(res => {
            if(res && res.data){
                setMetricesData(res.data);
            }else{
                toastMessage('error', (res && res.message) || 'Unable to load the jobs metrics');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });

        reportType.getJobsCount().then(res => {
            if(res && res.data){
                setJobsCountData(res.data);
            }else{
                toastMessage('error', (res && res.message) || 'Unable to load the jobs count');
            }
            dispatch(commonActions.pageLoading(false));
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    const updateJobStatus = async (status) => {
        setJobNotifyModal(false);
        let payload = {
            JobId: jobID,
            UserId: userData.UserId,
            Status: status
        };

        let res = await jobsActions.UpdateAgentSelectionStatus(payload);
        if(res.status === 200){
            dispatch(commonActions.pageLoading(true));
            setTimeout(() => {
                toastMessage('success', 'Your Response has been submitted to Aamer');
                history.push((status === 'Accepted') ? `/jobs/${jobID}` : '/jobs?reload=true');
                dispatch(commonActions.pageLoading(false));
            }, 1000);
        }else{
            toastMessage('error', (res && res.message) || 'Try again later');
        }       
    }

    const closeModal = () =>{
        setJobNotifyModal(false);
    }

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <div className="container-fluid">
            <div className="page-title-box">
                <h4 className="page-title">{t("dashboard.title")}</h4>
            </div>
            {pageLoading ? <div className="d-flex align-items-center justify-content-center h-75vh"><Loader type="ThreeDots" color="#2d207d" height={40} width={40} /></div>
                : <div>
                    <div className="row col-md-12">
                        <div className="notification-container col-md-12">
                            <h5>{t("dashboard.notifications")}</h5>
                            {(notificationData.length === 0) ? <p className="d-flex align-items-center justify-content-center">No notification Available</p> 
                                : <div className="pt-10 pb-10">
                                    <div className="card">
                                        <h5 className="ps-4 pt-2">{t("dashboard.awaitingResponseTable.title")}</h5>
                                        <div className="card-body pt-0">
                                            <div className="card-body p-3">
                                                <div className="tab-content">
                                                    <div className="table-responsive">
                                                        <table className="table table-head-custom table-vertical-center table-head-bg">
                                                            <thead>
                                                                <tr className="text-left">
                                                                    <th className="c-pointer" style={{width: '60px'}}>{t("dashboard.awaitingResponseTable.sNo")}</th>
                                                                    <th>{t("dashboard.awaitingResponseTable.id")}</th>
                                                                    <th>{t("dashboard.awaitingResponseTable.user")}</th>
                                                                    <th>{t("dashboard.awaitingResponseTable.customerName")}</th>
                                                                    <th>{t("dashboard.awaitingResponseTable.passportNo")}</th>
                                                                    {/* <th>{t("dashboard.awaitingResponseTable.department")}</th>
                                                                    <th>{t("dashboard.awaitingResponseTable.masterProcess")}</th>
                                                                    <th>{t("dashboard.awaitingResponseTable.process")}</th> */}
                                                                    {/* <th>Staff</th> */}
                                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("dashboard.awaitingResponseTable.status")}</span></th>
                                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("dashboard.awaitingResponseTable.action")}</span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {notificationData.map(({customerInfo, jobInfo, masterProcessName, processName, staffInfo, jobId, status}, index) => {
                                                                    // let statusClass  = (status.toLowerCase() === 'completed') ? 'success' : ((status.toLowerCase() === 'cancelled') ? 'danger' : 'purple');
                                                                    return(
                                                                        <tr key={index}>
                                                                            <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index+1}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.jobId}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{customerInfo}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.passportNo ? jobInfo.name : "-"}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.passportNo ?? "-"}</span>
                                                                            </td>
                                                                            {/* <td className="pl-0 py-8">
                                                                                <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{jobInfo.departmentName}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.masterProcessName}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobInfo.processName}</span>
                                                                            </td> */}
                                                                            {/* <td>
                                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{staffInfo}</span>
                                                                            </td> */}
                                                                            <td style={{whiteSpace: 'nowrap'}}>
                                                                                <span style={{color: '#b71c1c'}}>{status}</span>
                                                                            </td>
                                                                            <td className="pr-0">
                                                                                <p onClick={() => {setJobNotifyModal(true); setJobID(jobInfo.jobId); setJobData({customerInfo, jobInfo});}} className="btn btn-info font-weight-bolder font-size-sm mr-3">{t("dashboard.awaitingResponseTable.respond")}</p>
                                                                            </td>
                                                                        </tr>
                                                                    )})}
                                                            </tbody>
                                                        </table>
                                                        {(notificationData.length === 0) && <p className="text-center mt-5 mb-5">{t("dashboard.noDataAvailable")}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            {jobNotifyModal && <Modal jobTitle={'New Request'} jobData={jobData} title={'New Job Request'} type={'notification'} showModal={jobNotifyModal} handleOk={updateJobStatus} handleCancel={updateJobStatus} footerOption1={'Accept'} footerOption2={'Decline'} handleModalClose={closeModal} />}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="card row flex-row col-lg-12 my-4">
                        <div className="col-lg-12">
                            <JobsCount data={jobsCountData} history={history} />
                        </div>
                    </div>
                    <div className="card row flex-row col-lg-12 mb-4">
                        <h4 style={{marginTop: '15px', marginLeft: '15px'}}>{t("dashboard.overAll")}</h4>
                        <div className="col-lg-12">
                            <JobsCount2 data={overAllCount} history={history} />
                        </div>
                    </div>
                    <div className="card row flex-row col-lg-12 mt-5">
                        <div className="col-lg-6">
                            <AdminJobsChart data={adminJobsData} name={t("dashboard.jobsStatus")} />
                        </div>
                        {(slaJobsData.length !== 0) && <div className="col-lg-6">
                            <SLAJobsChart data={slaJobsData.slaInfor} avgTime={slaJobsData.averageTime} name={t("dashboard.jobsTurnaroundTime")} />
                        </div>}
                    </div>
                    <div className="card row flex-row col-lg-12 pb-4">
                        <div className="col-lg-6">
                            <HorizontalBarChart data={[{key: 'Total Jobs', value: metricesData.numberOfJobs}, {key: 'Active Jobs', value: metricesData.numberOfActiveJobs}, {key: 'Total Staffs', value: metricesData.numberOfStaffs}]} name={t("dashboard.otherMetrics")} />
                        </div>
                        <div className="col-lg-6">
                            <Metrics data={metricesData.staffJobCount} name={t("dashboard.jobsStaffMetrics")} />
                        </div>
                    </div>
                    <div className="card row flex-row col-lg-12 pb-4">
                        <div className="col-lg-6">
                            <RecentJobs data={recentJobsJobsData.recentJobProcesses} name={t("dashboard.recentJobProcess")} />
                        </div>
                        <div className="col-lg-6">
                            <RecentJobs data={recentJobsJobsData.recentJobStatuses} name={t("dashboard.recentJobStatus")} />
                        </div>
                    </div>
                </div>
            }
            {flyerNotificationConfigs.data?.length ?
                <FlyerModal 
                    id={flyerNotificationConfigs?.id} 
                    url={flyerNotificationConfigs?.url}
                    updateStatus={updateStatus}
                    loading={flyerNotificationConfigs.loading}
                /> : null
            }
        </div>
    );
};

export default Dashboard;